var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "RMstep1",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.addRawMaterial($event)
                  },
                  change: function ($event) {
                    return _vm.submitForm()
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { "label-for": "mc-Raw Material-name" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(" Raw Material Name "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v("(*)")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Raw Material Name",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            id: "mc-Raw Material-name",
                                            placeholder: "Raw Material Name",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.form.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "name", $$v)
                                            },
                                            expression: "form.name",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Raw Material Code",
                              "label-for": "mc-Raw Material-Code",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                type: "text",
                                id: "mc-Raw Material-Code",
                                placeholder: "Raw Material Code",
                              },
                              model: {
                                value: _vm.form.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "code", $$v)
                                },
                                expression: "form.code",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Low Stock Threshold" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(" Low Stock Threshold "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v("(*)")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Low Stock Threshold",
                                vid: "code",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-stock",
                                            type: "number",
                                            placeholder: "Low Stock Threshold",
                                            required: "",
                                          },
                                          on: {
                                            keypress: function ($event) {
                                              return _vm.allowOnlyNumbers(
                                                $event
                                              )
                                            },
                                            wheel: function ($event) {
                                              return _vm.allowOnlyNumbers(
                                                $event
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.form.lowStock,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "lowStock",
                                                $$v
                                              )
                                            },
                                            expression: "form.lowStock",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-for": "mc-stock-threshold",
                              label: "Unit of Measure (UOM)",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.itemUoms,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.form.defaultUomID,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "defaultUomID", $$v)
                                },
                                expression: "form.defaultUomID",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Price (Rs)",
                              "label-for": "Price",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                type: "number",
                                id: "mc-Raw Material-Price",
                                placeholder: "Raw Material Price",
                              },
                              on: {
                                keypress: function ($event) {
                                  return _vm.allowOnlyNumbers($event)
                                },
                                wheel: function ($event) {
                                  return _vm.allowOnlyNumbers($event)
                                },
                              },
                              model: {
                                value: _vm.form.purchasePrice,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "purchasePrice", $$v)
                                },
                                expression: "form.purchasePrice",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { "label-for": "mc-Category" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(" Category "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v("(*)")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Category", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.parentCategoryList,
                                            "value-field": "id",
                                            "text-field": "name",
                                            required: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.fetchCategoryDetails(
                                                _vm.form.categoryID
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.form.categoryID,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "categoryID",
                                                $$v
                                              )
                                            },
                                            expression: "form.categoryID",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Preferred Supplier",
                              "label-for": "mc-Supplier",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.suppliers,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.form.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "supplierId", $$v)
                                },
                                expression: "form.supplierId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              disabled: _vm.form.categoryID != null,
                              label: "Sub Category",
                              "label-for": "mc-subCategory",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.subCategoryList,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.form.ProductCategorySubId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "ProductCategorySubId",
                                    $$v
                                  )
                                },
                                expression: "form.ProductCategorySubId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "mb-2", attrs: { cols: "12" } },
                      [
                        _c("label", { attrs: { for: "textarea-default" } }, [
                          _vm._v("Raw Material Description"),
                        ]),
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-default",
                            placeholder: "Raw Material Description",
                            rows: "5",
                          },
                          model: {
                            value: _vm.form.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "description", $$v)
                            },
                            expression: "form.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("CustomFieldsDetails", {
                  attrs: {
                    AdditionalFields: _vm.form.additionalFields,
                    ModuleReference: "RawMaterial",
                  },
                  on: { onchange: _vm.additionalFieldChanges },
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }